import { render, staticRenderFns } from "./MyCourseEvaluation.vue?vue&type=template&id=8e1c24ec&scoped=true"
import script from "./MyCourseEvaluation.vue?vue&type=script&lang=ts"
export * from "./MyCourseEvaluation.vue?vue&type=script&lang=ts"
import style0 from "./MyCourseEvaluation.vue?vue&type=style&index=0&id=8e1c24ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1c24ec",
  null
  
)

export default component.exports